import type { BufferGeometry } from '@seddi/three';

import type { StyleLogoRegion } from '../api/styleAggregator';
import type { FrameBounds } from './frameLookAt';
import { computeFrameBounds as computeGeometryFrameBounds } from './frameBufferGeometryRegion';
import { finishFrameBounds } from './frameStyleRegion';

export const computeFrameBounds = (
  region: StyleLogoRegion,
  geometry: BufferGeometry,
): FrameBounds => {
  const bounds = computeGeometryFrameBounds(region, geometry);
  finishFrameBounds(region, bounds);
  return bounds;
};
